import { render, staticRenderFns } from "./SlideShowSettings.vue?vue&type=template&id=c39b265c"
import script from "./SlideShowSettings.vue?vue&type=script&lang=js"
export * from "./SlideShowSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports